module.exports = __webpack_public_path__ + "img/pf.87a01544.svg";